import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditSpeakerPayload } from '@app-store/slices/speakers/editSpeaker'

interface TaskAction extends Action {
    payload: IEditSpeakerPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.speakers.edit

function* editSpeakerSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/event/speaker/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editSpeakerSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editSpeakerSagaTask)
}

export default editSpeakerSaga
